export default __webpack_public_path__ + "static/media/the-racer2.580f15cd.jpg";